import { Component, OnInit } from '@angular/core';
import { Network } from '@ngx-pwa/offline';

@Component({
  selector: 'app-pwa-offline-indicator',
  templateUrl: './pwa-offline-indicator.component.html',
  styleUrls: ['./pwa-offline-indicator.component.css']
})
export class PwaOfflineIndicatorComponent implements OnInit {

  networkStatus$;

  constructor(protected network: Network) { 
    this.networkStatus$ = this.network.onlineChanges;
  }

  ngOnInit() {
  }

}